<template>
  <mdb-container>
    <EditNotification
      :notification-type="this.$store.state.timednotification"
      :default-marker="marker"
    />
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditNotification from "@/components/EditNotification.vue";

export default {
  name: "AddTimedNotification",
  components: {
    mdbContainer,
    EditNotification
  },
  data() {
    return {
      marker: {
        name: "Helsinki",
        position: { lat: 60.1733244, lng: 24.9410248 },
        radius: 3000
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
